module.exports = __webpack_public_path__ + "i18n/ru.37dbf98cd15159b06e0013903b9ad126.json";